import React from "react";
import { Container, Row, Col, Jumbotron } from "reactstrap";
import styles from "./Hero.module.scss";

const Hero = ({ background, text, cta, darkOverlay = true }) => {
  return (
    <div
      className={styles.hero}
      style={{
        backgroundImage: background.type !== 'video' && background?.url ? `url(${background?.url})` : undefined,
      }}
    >
      {background.type === 'video'
        ? <video className={styles.video} autoPlay muted loop>
          <source src={background.url} type={background.mime} />
        </video>
        : null}
      {darkOverlay ? <div className={styles.heroOverlay} /> : null}
      <Container>
        <Row>
          <Col xs={12} md={9}>
            <h1 className={styles.headerTitle}>{text}</h1>
          </Col>
        </Row>
        {cta ? (
          <Row className="mt-4">
            <Col>{cta}</Col>
          </Row>
        ) : null}
      </Container>
    </div>
  );
};

export default Hero;
